import * as React from "react";
import ReactPagination from "react-js-pagination";
import styled from "styled-components";
import {TPagination} from "../../../type/common";
import {ConstColor, ConstFontStyle, ConstFontWeight, ConstZIndex} from "../../../../config/styles_const/styles_const";
import Paragraph from "../../atom/text/paragraph";

interface IProps
{
    paginationPrams: TPagination;
}

const Pagination: React.FC<IProps> = (props) => {

    const {
        paginationPrams,
    } = props;

    return (
        <PaginationWrapper>
            <ReactPagination
                {...paginationPrams}
                nextPageText={<ArrowIcon icon={"'\f054'"}/>}
                prevPageText={<ArrowIcon icon={"'\f053'"}/>}
                hideDisabled={true}
                hideFirstLastPages={true}
                innerClass={"innerClass"}
                activeClass={"activeClass"}
                activeLinkClass={"activeLinkClass"}
                itemClass={"itemClass"}
                linkClass={"linkClass"}
                itemClassPrev={"itemClassPrev"}
                itemClassNext={"itemClassNext"}
            />
        </PaginationWrapper>
        )

};

export default Pagination

const PaginationWrapper = styled.div`
    & .innerClass {
        display: table;
        font-size: ${ConstFontStyle.ParagraphDefault.fontSize};
        font-weight: ${ConstFontWeight.BOLD}
        padding-left: 0;
        margin: 20px auto;
        overflow: hidden;
    }
    
    & .activeClass {
        background-color: ${ConstColor.White};
        border-color: ${ConstColor.Corporate};
        border-bottom: 3px solid ${ConstColor.Corporate} !important;
    }
    
    & .activeLinkClass {
        z-index: ${ConstZIndex.pagination};
        color: ${ConstColor.Corporate} !important;
        cursor: default;
    }
    
    & .itemClass {
        width: 50px;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        float: left;
        text-decoration: none;
        border-bottom: 3px solid ${ConstColor.White};
        :hover {
            border-color: ${ConstColor.Corporate};
            border-bottom: 3px solid ${ConstColor.Corporate};
        }
    }
    
    & .linkClass {
        display: block;
        padding: 6px 12px;
        color: ${ConstColor.Base};
    }
    
    & .itemClassNext {
    }
    
    & .itemClassPrev {
    }
    
`;

const ArrowIcon = styled(Paragraph)`
    color: inherit;
    ::before {
        margin-right: 0;
    }
`;


// WEBPACK FOOTER //
// ./src/presentation/common/molecular/pagination/pagination.tsx